import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/ServicesPage.css';
import Breadcrumbs from '../components/Breadcrumbs';
import Studio1 from '../assets/Services/Recording_5_TALL.png';

const StudioPage = () => (
  <div className="service-page">
    <Breadcrumbs />
    <h1>Studio & Production</h1>

    <div className="service-content">
      <div className="service-image-wrapper">
        <img
          src={Studio1}
          alt="Studio Engineer Recording Session"
          className="service-image"
        />
      </div>

      <div className="service-description">
        <p>
          Whether you're laying down a rough demo or producing a polished album, our Studio &amp; Production services are designed to bring your music to life. From{' '}
          <Link to="/services/studio/recording">Recording, Mixing &amp; Mastering</Link> to final production touches, we help shape your sound with clarity and impact. We also offer <strong>Mobile Recording</strong>, delivering studio-quality sessions in your own space for maximum comfort and creativity.
        </p>

        <p>
          Beyond audio, <strong>The Westchester Music Lab</strong> also provides{' '}
          <Link to="/services/studio/visual">Professional Photo &amp; Video</Link> services tailored to musicians and performers. Capture a live session, create promo content, or build cohesive brand visuals that elevate your online presence.
        </p>

        <h2 className="service-section-heading">Services Provided</h2>
        <ul className="service-list">
          <li>Multi-track recording for vocals and instruments</li>
          <li>Professional mixing and mastering</li>
          <li>Mobile recording setup available on location</li>
          <li>Compositional production services</li>
          <li>Promotional photography and video</li>
          <li>Branding content including logos and flyers</li>
        </ul>
      </div>
    </div>

    <div className="service-cta">
      <Link to="/contact" className="cta-button">
        Book a Session
      </Link>
    </div>
  </div>
);

export default StudioPage;
